var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { MaskedTextField as FluentMaskedTextField, TextField as FluentTextField } from "@fluentui/react";
import { useCallback, useState } from "react";
var BaseTextField = function (props) {
    var alwaysDisplayError = props.alwaysDisplayError, onGetErrorMessage = props.onGetErrorMessage, _error = props.errorMessage, onBlur = props.onBlur, Component = props.Component, onChange = props.onChange, rest = __rest(props, ["alwaysDisplayError", "onGetErrorMessage", "errorMessage", "onBlur", "Component", "onChange"]);
    var _a = useState(false), displayError = _a[0], setDisplayError = _a[1];
    var _b = useState(), error = _b[0], setError = _b[1];
    var activate = useCallback(function (err) {
        if (err === "" && !displayError)
            setDisplayError(true);
    }, [displayError]);
    var handleFocusOut = useCallback(function (evt) {
        setDisplayError(true);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(evt);
    }, [onBlur]);
    var handleChange = useCallback(function (evt, value) { return __awaiter(void 0, void 0, void 0, function () {
        var err, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    onChange === null || onChange === void 0 ? void 0 : onChange(evt, value);
                    if (!onGetErrorMessage) return [3, 2];
                    return [4, onGetErrorMessage(value || "")];
                case 1:
                    _a = ((_b.sent()) || "");
                    return [3, 3];
                case 2:
                    _a = undefined;
                    _b.label = 3;
                case 3:
                    err = _a;
                    activate(err);
                    setError(err || "");
                    return [2];
            }
        });
    }); }, [onGetErrorMessage, onChange, activate]);
    activate(onGetErrorMessage ? _error : _error || "");
    return _jsx(Component, __assign({ onBlur: handleFocusOut, onChange: handleChange, errorMessage: displayError || alwaysDisplayError ? error || _error : undefined }, rest), void 0);
};
export var TextField = function (props) {
    return _jsx(BaseTextField, __assign({ Component: FluentTextField }, props), void 0);
};
export var MaskedTextField = function (props) {
    return _jsx(BaseTextField, __assign({ Component: FluentMaskedTextField }, props), void 0);
};
//# sourceMappingURL=TextField.js.map